/**
 * Display helpers shared by the RSI Momentum pages. Formatting ONLY -- stored
 * values, API values and calculations are never changed.
 *
 *  istText(): every timestamp as "YYYY-MM-DD HH:MM:SS IST".
 *    - an ISO string WITH an offset/"Z" (e.g. a UTC-stored created_at /
 *      updated_at / order-event time) is converted to IST;
 *    - an ISO string WITHOUT an offset is read as IST wall-clock (the
 *      backtest's naive IST convention);
 *    - a string already ending in " IST" is returned unchanged.
 *  fmt2(): exactly 2 decimals (en-IN grouping), "—" when missing.
 */
const IST_MS = (5 * 60 + 30) * 60 * 1000;
const pad = (n: number) => String(n).padStart(2, "0");

export function istText(v: string | null | undefined): string {
  if (!v) return "—";
  if (/ IST$/.test(v)) return v;
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/.exec(v.trim());
  if (!m) return v;
  if (!m[7]) return `${m[1]}-${m[2]}-${m[3]} ${m[4]}:${m[5]}:${m[6] ?? "00"} IST`;
  const t = Date.parse(v);
  if (Number.isNaN(t)) return v;
  const d = new Date(t + IST_MS);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())} IST`;
}

export const fmt2 = (v: number | null | undefined): string =>
  v === null || v === undefined || !Number.isFinite(v) ? "—" : v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Signed value with a NON-BREAKING minus (U+2212) so "−₹5,938.54" can never wrap after the sign. */
export const signed = (s: string): string => s.replace(/^-/, "−");
